import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69b03eed886e100014a6addc/tgvision2047/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b03eed886e100014a6addc/tgvision2047/src/app/reality-tracker/components/TrackerDashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b03eed886e100014a6addc/tgvision2047/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b03eed886e100014a6addc/tgvision2047/src/components/ui/AppLogo.tsx");
